import { useFormContext } from 'react-hook-form';
import { Locales } from '@locales/en.ts';
import type { FormInput } from './CreateVirtualEVSEForm.tsx';
import { CUSTOM_MODEL_VALUE } from './CreateVirtualEVSEForm.tsx';
import type { FC } from 'react';
import { FormAutocomplete } from '@components/forms/FormAutocomplete.tsx';
import { useFindModelsQuery } from '@services/queries/use-find-models.query.ts';
import { Stack } from '@components/atoms';

// TextField wrapper to get "vendor" and "model" attributes from form state
export const CustomModelTextFields: FC = () => {
  const { data: models, isLoading: isLoadingModels } = useFindModelsQuery();

  const { watch } = useFormContext<FormInput>();
  const selectedModel = watch('model' as keyof FormInput);

  const vendorsOptions: string[] = (models || []).map(([key]) => key);
  const modelsOptions: string[] = (models || []).map(([, value]) => value);

  if (selectedModel !== CUSTOM_MODEL_VALUE) {
    return null;
  }

  return (
    <Stack direction='row' width='100%' spacing={2}>
      <FormAutocomplete
        name={'customVendor' as keyof FormInput}
        options={vendorsOptions}
        disabled={isLoadingModels}
        freeSolo
        fullWidth
        textFieldProps={{
          label: Locales.labels.customVendor,
          placeholder: 'ev.energy',
        }}
      />
      <FormAutocomplete
        name={'customModel' as keyof FormInput}
        placeholder='Virtual charger'
        options={modelsOptions}
        disabled={isLoadingModels}
        freeSolo
        fullWidth
        textFieldProps={{
          label: Locales.labels.customModel,
          placeholder: 'Virtual charger',
        }}
      />
    </Stack>
  );
};
